import { render, staticRenderFns } from "./source-selector.vue?vue&type=template&id=21a2f8b8&"
import script from "./source-selector.vue?vue&type=script&lang=js&"
export * from "./source-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports